/**
 * セクション詳細ページ専用i18n定数
 */

export const SECTION_DETAILS_I18N = {
  // 契約ステータス
  contractStatus: {
    active: $localize`:@@sectionGroupAdmin.sectionDetails.contractStatus.active:有効`,
    inactive: $localize`:@@sectionGroupAdmin.sectionDetails.contractStatus.inactive:無効`,
  },

  // 管理者割り当て
  assignAdmin: {
    assignLater: $localize`:@@sectionGroupAdmin.sectionDetails.assignAdmin.assignLater:管理者をあとで割り当てる`,
    assignSelf: $localize`:@@sectionGroupAdmin.sectionDetails.assignAdmin.assignSelf:自分自身を管理者にする`,
  },

  // ユーザ 姓名とコードのどちらを使うか
  userNameOrCode: {
    name: $localize`:@@sectionGroupAdmin.sectionDetails.userNameOrCode.name:姓名を指定`,
    code: $localize`:@@sectionGroupAdmin.sectionDetails.userNameOrCode.code:コードを指定`,
  },

  sexOptions: {
    male: $localize`:@@sectionGroupAdmin.sectionDetails.sexOptions.male:男性`,
    female: $localize`:@@sectionGroupAdmin.sectionDetails.sexOptions.female:女性`,
    other: $localize`:@@sectionGroupAdmin.sectionDetails.sexOptions.other:その他`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@sectionGroupAdmin.sectionDetails.dialog.confirmTitle:ダイアログ確認`,
  },

  // ボタン
  button: {
    close: $localize`:@@sectionGroupAdmin.sectionDetails.button.close:閉じる`,
  },

  // バリデーションメッセージ
  validation: {
    checkFields: $localize`:@@sectionGroupAdmin.sectionDetails.validation.checkFields:各フィールドの内容を再度確認してください`,
  },

  // メッセージ
  message: {
    createSuccess: $localize`:@@sectionGroupAdmin.sectionDetails.message.createSuccess:セクションを作成しました。`,
    createWithAdminSuccess: $localize`:@@sectionGroupAdmin.sectionDetails.message.createWithAdminSuccess:セクションを作成し、現在のユーザーを管理人として登録しました。`,
    createAdminError: $localize`:@@sectionGroupAdmin.sectionDetails.message.createAdminError:セクションを登録しましたが、新しく作成したセクションに管理者を登録するのを失敗しました。システム管理者にご連絡ください。`,
    createError: $localize`:@@sectionGroupAdmin.sectionDetails.message.createError:セクションの登録に失敗しました。`,
    updateSuccess: $localize`:@@sectionGroupAdmin.sectionDetails.message.updateSuccess:セクションの情報を更新しました。`,
    updateError: $localize`:@@sectionGroupAdmin.sectionDetails.message.updateError:セクションの情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
  },
} as const;

export type SectionDetailsI18n = typeof SECTION_DETAILS_I18N;
